import { createContentVersionAnnotation } from './create'
import { readContentVersionAnnotations } from './read'
import { updateContentVersionAnnotation } from './update'

export * from './types'

export const contentVersionAnnotations = {
  readCollection: readContentVersionAnnotations,
  create: createContentVersionAnnotation,
  update: updateContentVersionAnnotation,
}
